var map = {
	"./assets/icons.js": [
		1281,
		746
	],
	"./configKeyShortcuts.js": [
		233
	],
	"./controls/EmbedButton.js": [
		1358,
		747
	],
	"./controls/helpers.js": [
		1285,
		748
	],
	"./controls/hlsResolutionMenu.js": [
		1306,
		685
	],
	"./controls/mp4ResolutionMenu.js": [
		1307,
		686
	],
	"./controls/news/rewind.js": [
		1355,
		681
	],
	"./controls/news/seasonList.js": [
		1361,
		679
	],
	"./controls/news/skip.js": [
		1356,
		682
	],
	"./controls/news/title.js": [
		1357,
		0,
		749
	],
	"./controls/rewind.js": [
		1359,
		683
	],
	"./controls/skip.js": [
		1360,
		684
	],
	"./drmObject.js": [
		232
	],
	"./ima/autoplay.js": [
		962,
		246
	],
	"./ima/videojs.ima.js": [
		579
	],
	"./index.js": [
		295
	],
	"./neouskin.js": [
		1370,
		19,
		678
	],
	"./newsSkin.js": [
		633,
		0,
		19,
		28
	],
	"./registerVjsComponent.js": [
		1305,
		750
	],
	"./screens/Embed.js": [
		262
	],
	"./screens/embedWall.js": [
		264
	],
	"./screens/nextVideoTimer.js": [
		231
	],
	"./screens/rating.js": [
		263
	],
	"./screens/upgrade.js": [
		607
	],
	"./screens/videoWall.js": [
		605
	],
	"./screens/waysToWatch/index.js": [
		608
	],
	"./skin.js": [
		1371,
		19,
		677
	],
	"./video.js": [
		609
	],
	"./video06.js": [
		606
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 664;
module.exports = webpackAsyncContext;